import { HttpClient } from '@sdir/httpclient/lib/HttpClient';
import { OpenApi as RequirementOpenApi } from '@sdir/httpclient/lib/clients/core/requirement';
import { InternalApi as EndorsementApi } from '@sdir/httpclient/lib/clients/aps/endorsement';
import { InstitutionCourseApi } from '@sdir/httpclient/lib/clients/aps/course';

const clientId = 'msp';
const authority = process.env.REACT_APP_EXTERNALAUTHURL || '';
const baseUrl = process.env.REACT_APP_API_URL;
const httpClient = new HttpClient(baseUrl);

httpClient.addAPIMSubscriptionKeyHeader(process.env.REACT_APP_SUBSCRIPTIONKEY);
httpClient.addOICDAuthorizationHeader(authority, clientId);

export const endorsementApi = new EndorsementApi(
  undefined,
  `${baseUrl}/aps-endorsement-internal`,
  httpClient.client
);

export const courseInstitutionApi = new InstitutionCourseApi(
  undefined,
  `${baseUrl}/aps-course-internal`,
  httpClient.client
);

export const simulationApi = new RequirementOpenApi(
  undefined,
  `${baseUrl}/core-requirement-internal`,
  httpClient.client
);
